import {createAction} from "redux-act";
import {SortColumnOrder, SortColumnType} from "modules/utils";

export interface ISortTablePayload {
	sort: SortColumnType;
	order?: SortColumnOrder;
}

export const sortTable = createAction<ISortTablePayload>();
